<template>
  <VaConfig>
    <VaLayout>
      <template #sidebar>
        <AppSidebar />
      </template>
      <template #content>
        <RouterView></RouterView>
      </template>
    </VaLayout>
  </VaConfig>
</template>

<script setup lang="ts">
import { onMounted, watch } from 'vue'
import { useThemeStore } from './stores/theme-store'
import { useColors } from 'vuestic-ui'
import AppSidebar from './components/sidebar/AppSidebar.vue'

const themeStore = useThemeStore()

// Initialize theme store
onMounted(() => {
  themeStore.initSystemTheme()

  // Apply initial theme
  themeStore.applyCustomTheme(themeStore.theme)
  try {
    const colors = useColors()
    if (colors?.applyPreset) {
      colors.applyPreset(themeStore.theme)
    }
  } catch (e) {
    console.warn('Could not apply initial vuestic preset:', e)
  }

  // Watch for theme changes
  watch(
    () => themeStore.theme,
    (newTheme) => {
      themeStore.applyCustomTheme(newTheme)
    },
  )

  // Watch system theme and apply if no user preference is set
  watch(
    () => themeStore.systemTheme,
    (newSystemTheme) => {
      if (!localStorage.getItem('theme')) {
        themeStore.theme = newSystemTheme
      }
    },
  )
})
</script>

<style lang="scss">
@use 'scss/main.scss';
@import 'styles/notivue-login.css';

#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  min-width: 20rem;
}
</style>
